// Extern Modules

import 'slick-carousel';
import countUp from './extras/countUp';

// Intern Modules

import OnePageNav from 'purejs_onepagenav';
import ReadMore from './extras/readMore';
import { ElementsBlocker, IFramesBlocker } from './modules/ElementsBlocker/dist/Blockers';
import initFslightbox from './modules/fslightbox';

function initializeOnePageNavs() {
    if (!$('body').hasClass('onepager')) return;

    // https://github.com/Matheoz-sys/PureJS_OnePageNav/wiki/Configuration

    new OnePageNav({
        navLinksSelector: 'body.onepager #header .main-nav .level_1 a:not(.invisible)',
        defaultLinkActive: true,
        updateATagClass: false,
        parentsObtainingActiveClass: ['li'],
        changeOffset: 33,
    });

    new OnePageNav({
        navLinksSelector: 'body.onepager #header-fixed .main-nav .level_1 a:not(.invisible)',
        defaultLinkActive: true,
        updateATagClass: false,
        parentsObtainingActiveClass: ['li'],
        changeOffset: 33,
    });
}

// No-cookie iFrames Blocker =============================
function blockIframes() {
    new IFramesBlocker('.ce_youtube.simply-blocked iframe', {
        headline: 'Youtube Video',
        message: {
            content:
                'Da soll eine hinweis Text kommen. Bei mehreren fragen, melden sich bitte bei Mateusz. Nach kurze überlegung, vielleicht wäre es nicht schlechte Idee eine große bereich mit diesen Blokierer und texte erstellen? - Wo man sich immer die Texte anshauen/kopieren kann.',
        },
        button: {
            content: 'Video einschalten',
        },
        image: {
            source: 'files/theme/js/modules/ElementsBlocker/images/YouTubeLogo.svg', // Use PNG, oder auf alte iSysteme wird das logo nicht geladen
            width: 150,
        },
        cssFiles: ['files/theme/js/modules/ElementsBlocker/dist/IFramesBlocker.min.css'],
        // iFrame soll nicht kleiner als Text drinnen sein - geht nicht, wenn Parent über padding-bottom gesteuert wird
        // adjustHeight: true, // is default true
        // inside onLoad, can be given path to script, or normal callback
        onLoad: [
            // 'pathToJs.js',
            function (iframe) {
                // Or callback function
                console.log(iframe);
            },
        ],
    });

    new ElementsBlocker('', {
        caching: false,
        logo: {
            source: 'files/theme/js/modules/ElementsBlocker/images/YouTubeLogo.svg',
            width: '150px',
        },
        headline: {
            content: 'Blocker Headline',
        },
        message: {
            content: 'Blocker message',
        },
        button: {
            content: 'Blocker bestätigen',
        },
        containerClass: 'special-class-for-parent-container',
        styles: 'files/theme/js/modules/ElementsBlocker/dist/IFramesBlocker.min.css',
        localStorage: {
            enabled: true,
            agreementWithdrawal: {
                legalContainer: '.datenschutz',
                headline: {
                    content: 'Take it off from me!',
                },
                message: {
                    content: 'Message von ein Element Blocker',
                },
                button: {
                    content: 'Destroy it!',
                },
            },
        },
    });
}

$(function () {
    ReadMore();
    countUp();
    initializeOnePageNavs();
    blockIframes();
    initFslightbox();
});
